import { render, staticRenderFns } from "./ResetPwdCmp.vue?vue&type=template&id=145c07f3&scoped=true"
import script from "./ResetPwdCmp.vue?vue&type=script&lang=js"
export * from "./ResetPwdCmp.vue?vue&type=script&lang=js"
import style0 from "./ResetPwdCmp.vue?vue&type=style&index=0&id=145c07f3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c07f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('145c07f3')) {
      api.createRecord('145c07f3', component.options)
    } else {
      api.reload('145c07f3', component.options)
    }
    module.hot.accept("./ResetPwdCmp.vue?vue&type=template&id=145c07f3&scoped=true", function () {
      api.rerender('145c07f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/CustomerList/cmp/ResetPwdCmp.vue"
export default component.exports